"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchQueryBuilder = void 0;
class QueryParam {
    constructor(type, key, value) {
        this.type = type;
        this.key = key;
        this.value = value;
    }
}
/**
 * Builder to build AxiosRequestConfig 'search' params
 * for accounting endpoints
 */
class SearchQueryBuilder {
    constructor() {
        this.queryParams = [];
    }
    static handleDate(date) {
        const year = date.getFullYear();
        const month = date.toLocaleDateString(undefined, { month: '2-digit' });
        const day = date.toLocaleDateString(undefined, { day: '2-digit' });
        return `${year}-${month}-${day}`;
    }
    in(key, values) {
        this.queryParams.push(new QueryParam('in', key, values));
        return this;
    }
    equals(key, value) {
        this.queryParams.push(new QueryParam('equals', key, value));
        return this;
    }
    like(key, value) {
        this.queryParams.push(new QueryParam('like', key, value));
        return this;
    }
    between(key, { min, max }) {
        if (min) {
            const value = min instanceof Date ? SearchQueryBuilder.handleDate(min) : min;
            this.queryParams.push(new QueryParam('between', `${key}_min`, value));
        }
        if (max) {
            const value = max instanceof Date ? SearchQueryBuilder.handleDate(max) : max;
            this.queryParams.push(new QueryParam('between', `${key}_max`, value));
        }
        return this;
    }
    build(resourceType) {
        let isAccountingLike = false;
        if (!resourceType || ['AccountingResource', 'EventsResource'].includes(resourceType)) {
            isAccountingLike = true;
        }
        let queryString = '';
        this.queryParams.forEach((param) => {
            const type = param.type;
            const key = param.key;
            const value = param.value;
            if (type === 'like' || type === 'between' || (type === 'equals' && isAccountingLike)) {
                queryString = queryString.concat(`&search[${key}]=${value}`);
            }
            else if (type === 'in' && value instanceof Array) {
                for (let i = 0; i < value.length; i += 1) {
                    queryString = queryString.concat(`&search[${key}][]=${value[i]}`);
                }
            }
            else {
                queryString = queryString.concat(`&${key}=${value}`);
            }
        });
        return queryString.substr(1);
    }
}
exports.SearchQueryBuilder = SearchQueryBuilder;
//# sourceMappingURL=SearchQueryBuilder.js.map